module.exports = __webpack_public_path__ + "img/image_4.cfd4bf2e.png";